import { render, staticRenderFns } from "./PubNotFound.vue?vue&type=template&id=58460f50&scoped=true&"
import script from "./PubNotFound.vue?vue&type=script&lang=js&"
export * from "./PubNotFound.vue?vue&type=script&lang=js&"
import style0 from "./PubNotFound.vue?vue&type=style&index=0&id=58460f50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58460f50",
  null
  
)

export default component.exports